import React, { useState, useEffect, useContext, useRef } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { searchFlowers } from "../components/Search";
import "../styles/Navbar.css";
import "../styles/SearchBar.css";
import "../styles/keyframes.css";
import logoImage from "../img/logo.webp";
import CartPopup from "../components/CartPopup";
import { CartContext } from "../components/CartContext";

const Navbar = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const navRef = useRef(null);

  const toggleDropdown = (dropdownName) => {
    setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
  };

  const closeNav = () => {
    setIsNavOpen(false);
  };

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  //SEARCHBAR
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const toggleSearchBar = () => setShowSearchBar(!showSearchBar);
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const handleSearchSubmit = (e) => {
    e.preventDefault();

    const results = searchFlowers(searchQuery);
    navigate("/search-results", { state: { results, query: searchQuery } });
    setShowSearchBar(false);
    setSearchQuery("");
  };

  useEffect(() => {
    if (isNavOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isNavOpen]);

  useEffect(() => {
    if (showSearchBar) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  });

  //CartPopup
  const [isCartPopupOpen, setIsCartPopupOpen] = useState(false);
  const { cartItems, removeFromCart } = useContext(CartContext);
  const handleCartButtonClick = () => {
    setIsCartPopupOpen(true);
  };

  const handleCloseCartPopup = () => {
    setIsCartPopupOpen(false);
  };

  // Add CSS to handle the dropdown visibility
  useEffect(() => {
    // Add this CSS to document
    const style = document.createElement("style");
    style.textContent = `
      .nav-item .dropdown.force-hide {
        display: none !important;
        opacity: 0 !important;
        visibility: hidden !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // Function to handle dropdown link clicks
  const handleDropdownLinkClick = (e) => {
    // Find all dropdown elements and add the force-hide class
    const dropdowns = document.querySelectorAll(".nav-item .dropdown");
    dropdowns.forEach((dropdown) => {
      dropdown.classList.add("force-hide");
    });

    // Remove the force-hide class after navigation completes (after 100ms)
    setTimeout(() => {
      dropdowns.forEach((dropdown) => {
        dropdown.classList.remove("force-hide");
      });
    }, 100);
  };

  return (
    <nav
      className={`flower-shop-navbar ${isNavOpen ? "nav__open" : ""}`}
      ref={navRef}
    >
      <div className="navbar-container">
        <div className="navbar-grid">
          <div className="navbar-left">
            <div className="social-contact-container">
              <ul className="social-media-list">
                <li>
                  <a
                    href="https://www.instagram.com/gardeniaflowers_md/"
                    className="btn social__media--link"
                    title="Instagram"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-instagram social__media--icon"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/profile.php?id=100083015576175"
                    className="btn social__media--link "
                    title="Facebook"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-facebook social__media--icon"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://wa.me/37378774774"
                    className="btn social__media--link"
                    title="WhatsApp"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-whatsapp social__media--icon"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://t.me/+37378774774"
                    className="btn social__media--link"
                    title="Telegram"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-telegram social__media--icon"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="navbar-right">
            <div className="right-content">
              <div className="contact">
                <a
                  href="tel:+37369374374"
                  className="btn phone-contact"
                  title="Telefon"
                >
                  <i className="fa-solid fa-phone"></i>
                  +373 78 774 774
                </a>
              </div>
              <div className="contact">
                <a
                  className="btn location-address"
                  href="https://www.google.com/maps/place/Strada+Petru+Rareș+37,+Chișinău,+Moldova/@47.0129097,28.8444433,17z"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Locatia"
                >
                  <i className="fas fa-location-dot"></i>
                  <span>Petru Rareș 37, Chișinău Moldova</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="navbar">
          <div className="navbar__left">
            <span
              className="mobile__nav"
              onClick={() => {
                toggleNav();
                toggleDropdown("");
              }}
            >
              <i className="mobile__nav--icon"></i>
            </span>
          </div>

          <div className="navbar__logo">
            <Link to="/" className="logo-link">
              <img src={logoImage} alt="Logo" />
            </Link>
          </div>
          <div className="navbar__right">
            <div className="navbar__search">
              <button className="btn search-button" onClick={toggleSearchBar}>
                <i className="fa-solid fa-magnifying-glass"></i>
              </button>
            </div>

            {showSearchBar && (
              <div
                className="searchbar-overlay"
                onClick={() => setShowSearchBar(false)}
              >
                <div
                  className={`search-bar-container ${
                    showSearchBar ? "active" : ""
                  }`}
                >
                  <form
                    className="search-bar"
                    onSubmit={handleSearchSubmit}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <input
                      type="text"
                      className="search-input"
                      placeholder="Cauta flori..."
                      value={searchQuery}
                      onChange={handleSearchChange}
                    />
                    <button type="submit" className="btn search-btn">
                      <i className="fa-solid fa-magnifying-glass"></i>
                    </button>
                  </form>
                </div>
              </div>
            )}

            <div className="btn navbar__cart">
              <button
                className="btn cart-button"
                onClick={handleCartButtonClick}
              >
                <i className="fa-solid fa-bag-shopping"></i>
                <span className="cart-count">{cartItems.length}</span>
              </button>
            </div>
          </div>
        </div>

        <div className="nav">
          <ul className="nav-links">
            <li className="nav-item">
              <Link to="/" className="btn nav-link">
                Pagina principala
              </Link>
            </li>
            <li className="nav-item">
              <Link to="" className="btn nav-link buchete-btn">
                Buchete & Compozitii
                <span className="arrow arrow-big"></span>
              </Link>
              <ul className="dropdown">
                <li>
                  <Link
                    className="dropdown-link"
                    to="/cele-mai-vindute"
                    onClick={handleDropdownLinkClick}
                  >
                    Cele mai vindute
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-link"
                    to="/buchete"
                    onClick={handleDropdownLinkClick}
                  >
                    Buchete
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-link"
                    to="/buchete-trandafiri"
                    onClick={handleDropdownLinkClick}
                  >
                    Buchete trandafiri
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-link"
                    to="/compozitii-in-cosuri-si-cutii"
                    onClick={handleDropdownLinkClick}
                  >
                    Compozitii in cosuri si cutii
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/buchete-premium">
                Buchete Premium
              </Link>
            </li>

            <li className="nav-item">
              <Link to="" className="btn nav-link buchete-btn">
                Ocazii speciale
                <span className="arrow arrow-big"></span>
              </Link>
              <ul className="dropdown">
                <li>
                  <Link
                    className="dropdown-link"
                    to="/14-februarie"
                    onClick={handleDropdownLinkClick}
                  >
                    14 Februarie
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-link"
                    to="/8-martie"
                    onClick={handleDropdownLinkClick}
                  >
                    8 Martie
                  </Link>
                </li>

                <li>
                  <Link
                    className="dropdown-link"
                    to="/buchete-de-mireasa"
                    onClick={handleDropdownLinkClick}
                  >
                    Buchete de mireasa
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <Link to="" className="btn nav-link buchete-btn">
                Buchete de sezon
                <span className="arrow arrow-big"></span>
              </Link>
              <ul className="dropdown">
                <li>
                  <Link
                    className="dropdown-link"
                    to="/compozitii-de-iarna"
                    onClick={handleDropdownLinkClick}
                  >
                    Compozitii de iarna
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-link"
                    to="/buchete-de-iarna/primavara"
                    onClick={handleDropdownLinkClick}
                  >
                    Buchete de iarna/primavara
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-link"
                    to="/buchete-de-vara"
                    onClick={handleDropdownLinkClick}
                  >
                    Buchete de vara
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-link"
                    to="/buchete-de-toamna"
                    onClick={handleDropdownLinkClick}
                  >
                    Buchete de toamna
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <Link className="btn nav-link" to="/despre-noi">
                Despre noi
              </Link>
            </li>
            <li className="nav-item">
              <Link className=" btn nav-link" to="/contact">
                Contacte
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {isNavOpen && (
        <div className={`sidebar ${isNavOpen ? "open" : ""}`}>
          <div
            className="sidebar-overlay"
            onClick={() => {
              closeNav();
              toggleDropdown("");
            }}
          ></div>
          <div className="sidebar-content">
            <ul className="nav-links">
              <li className="nav-item">
                <Link to="/" className="btn nav-link" onClick={closeNav}>
                  Pagina principala
                </Link>
              </li>
              <li className="nav-item">
                <button
                  className="btn nav-link buchete-btn"
                  onClick={() => toggleDropdown("Buchete & Compozitii")}
                >
                  Buchete & Compozitii
                  <span
                    className={`arrow ${
                      activeDropdown === "Buchete & Compozitii" ? "rotated" : ""
                    }`}
                  ></span>
                </button>
                {activeDropdown === "Buchete & Compozitii" && (
                  <ul className="dropdown-mobile">
                    <li>
                      <Link
                        className="dropdown-link"
                        to="/cele-mai-vindute"
                        onClick={() => {
                          closeNav();
                          toggleDropdown("");
                        }}
                      >
                        Cele mai vindute
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-link"
                        to="/buchete"
                        onClick={() => {
                          closeNav();
                          toggleDropdown("");
                        }}
                      >
                        Buchete
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-link"
                        to="/buchete-trandafiri"
                        onClick={() => {
                          closeNav();
                          toggleDropdown("");
                        }}
                      >
                        Buchete trandafiri
                      </Link>
                    </li>
                    <li>
                      <Link
                        className=" dropdown-link"
                        to="/compozitii-in-cosuri-si-cutii"
                        onClick={() => {
                          closeNav();
                          toggleDropdown("");
                        }}
                      >
                        Compozitii in cosuri si cutii
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/buchete-premium"
                  onClick={closeNav}
                >
                  Buchete Premium
                </Link>
              </li>
              <li className="nav-item">
                <button
                  className="btn nav-link buchete-btn"
                  onClick={() => toggleDropdown("Ocazii speciale")}
                >
                  Ocazii speciale
                  <span
                    className={`arrow ${
                      activeDropdown === "Ocazii speciale" ? "rotated" : ""
                    }`}
                  ></span>
                </button>
                {activeDropdown === "Ocazii speciale" && (
                  <ul className="dropdown-mobile">
                    <li>
                      <Link
                        className=" dropdown-link"
                        to="/14-februarie"
                        onClick={() => {
                          closeNav();
                          toggleDropdown("");
                        }}
                      >
                        14 Februarie
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-link"
                        to="/8-martie"
                        onClick={() => {
                          closeNav();
                          toggleDropdown("");
                        }}
                      >
                        8 Martie
                      </Link>
                    </li>

                    <li>
                      <Link
                        className="  dropdown-link"
                        to="/buchete-de-mireasa"
                        onClick={() => {
                          closeNav();
                          toggleDropdown("");
                        }}
                      >
                        Buchete de mireasa
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
              <li className="nav-item">
                <button
                  className="btn nav-link buchete-btn"
                  onClick={() => toggleDropdown("Buchete de sezon")}
                >
                  Buchete de sezon
                  <span
                    className={`arrow ${
                      activeDropdown === "Buchete de sezon" ? "rotated" : ""
                    }`}
                  ></span>
                </button>
                {activeDropdown === "Buchete de sezon" && (
                  <ul className="dropdown-mobile">
                    <li>
                      <Link
                        className=" dropdown-link"
                        to="/compozitii-de-iarna"
                        onClick={() => {
                          closeNav();
                          toggleDropdown("");
                        }}
                      >
                        Compozitii de iarna
                      </Link>
                    </li>
                    <li>
                      <Link
                        className=" dropdown-link"
                        to="/buchete-de-iarna/primavara"
                        onClick={() => {
                          closeNav();
                          toggleDropdown("");
                        }}
                      >
                        Buchete de iarna/primavara
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="  dropdown-link"
                        to="/buchete-de-vara"
                        onClick={() => {
                          closeNav();
                          toggleDropdown("");
                        }}
                      >
                        Buchete de vara
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="  dropdown-link"
                        to="/buchete-de-toamna"
                        onClick={() => {
                          closeNav();
                          toggleDropdown("");
                        }}
                      >
                        Buchete de toamna
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
              <li className="nav-item">
                <Link
                  className="btn nav-link"
                  to="/despre-noi"
                  onClick={closeNav}
                >
                  Despre noi
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className=" btn nav-link"
                  to="/contact"
                  onClick={closeNav}
                >
                  Contacte
                </Link>
              </li>
            </ul>

            <div className="nav-item">
              <ul className="social-media-list">
                <li>
                  <a
                    href="https://www.instagram.com/gardeniaflowers_md/"
                    className="btn social__media--link"
                    title="Instagram"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-instagram social__media--icon"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/profile.php?id=100083015576175"
                    className="btn social__media--link "
                    title="Facebook"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-facebook social__media--icon"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://wa.me/37378774774"
                    className="btn social__media--link"
                    title="WhatsApp"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-whatsapp social__media--icon"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://t.me/+37378774774"
                    className="btn social__media--link"
                    title="Telegram"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-telegram social__media--icon"></i>
                  </a>
                </li>
              </ul>
            </div>
            <div className="nav-item">
              <a
                href="tel:+37369374374"
                className="btn phone-contact"
                title="Telefon"
              >
                <i className="fa-solid fa-phone"></i>
                +373 78 774 774
              </a>
            </div>
            <div className="nav-item">
              <a
                className="btn location-address"
                href="https://www.google.com/maps/place/Strada+Petru+Rareș+37,+Chișinău,+Moldova/@47.0129097,28.8444433,17z"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-location-dot"></i>
                <span>Petru Rareș 37, Chișinău Moldova</span>
              </a>
            </div>
          </div>
        </div>
      )}
      <CartPopup
        isOpen={isCartPopupOpen}
        onClose={handleCloseCartPopup}
        cartItems={cartItems}
        removeFromCart={removeFromCart}
        total={cartItems.reduce(
          (sum, item) =>
            sum +
            item.price * item.quantity +
            (item.extras
              ? item.extras.reduce(
                  (extraSum, extra) => extraSum + extra.price,
                  0
                )
              : 0),
          0
        )}
      />
    </nav>
  );
};

export default Navbar;
